export const PATHS = {
  LOGIN: '/login',
  ACTIVATE_ACCOUNT: '/activate-account',
  REQUEST_PASSWORD_RESET: '/request-password-reset',
  REQUEST_PASSWORD_RESET_CONFIRMATION: '/request-password-reset-confirmation',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_CONFIRMATION: '/reset-password-confirmation',
};
